import React from "react";
import PropTypes from "prop-types";
import { ColumnPropTypes } from "../../props";

import { v4 as uuidv4 } from "uuid";

import Tr from "./row/tr";
import TdFoot from "./row/tdFoot";

function Tfoot({ columns, data, loading }) {
  // let rows = [];
  let cols = [];

  let withPrefix = false;
  let withTitle = false;
  let withSuffix = false;

  columns.forEach((column, i) => {
    if (typeof column === "object") {
      if (!column.hasOwnProperty("isRenderInBody") || !column.isRenderInBody) {
        if (
          column.hasOwnProperty("footer") &&
          typeof column.footer === "object"
        ) {
          if (!withPrefix) {
            if (column.prefix) {
              withPrefix = true;
            }
          }

          if (!withTitle) {
            if (column.title) {
              withTitle = true;
            }
          }

          if (!withSuffix) {
            if (column.suffix) {
              withSuffix = true;
            }
          }

          let footer = column.footer;

          if (footer.hasOwnProperty("display")) {
            if (footer.display) {
              cols.push(
                <TdFoot
                  column={column}
                  footer={footer}
                  i={i}
                  data={data}
                  loading={loading}
                  key={uuidv4()}
                />
              );
            }
          } else {
            cols.push(
              <TdFoot
                column={column}
                footer={footer}
                i={i}
                data={data}
                loading={loading}
                key={uuidv4()}
              />
            );
          }
        }
      }
    }
  });

  if (cols.length) {
    let withClass = getWithClass(withPrefix, withTitle, withSuffix);

    return (
      <tfoot>
        <Tr className={withClass}>{cols}</Tr>
      </tfoot>
    );
  } else {
    return null;
  }
}

function getWithClass(withPrefix, withTitle, withSuffix) {
  let withClass = "";

  if (withTitle) {
    if (withPrefix) {
      if (withSuffix) {
        withClass = "with-prefix-title-suffix";
      } else {
        withClass = "with-prefix-title";
      }
    } else {
      withClass = "with-title";
    }
  } else {
    if (withPrefix) {
      if (withSuffix) {
        withClass = "with-prefix-suffix";
      } else {
        withClass = "with-prefix";
      }
    } else {
      if (withSuffix) {
        withClass = "with-suffix";
      }
    }
  }

  return withClass;
}

Tfoot.defaultProps = {
  columns: [],
  data: [],
  loading: false
};

Tfoot.propTypes = {
  // Колонки
  columns: PropTypes.arrayOf(ColumnPropTypes),
  // Данные
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default Tfoot;
